// src/Component/hooks/useDeleteDetail_pengeluaran.jsx
import { useState } from 'react';
import api from '../Services/api';
import endpoints from '../Services/endpointAdmin';

/**
 * useDeleteDetailPengeluaran adalah custom hook yang digunakan untuk menghapus data detail pengeluaran dari backend.
 * @returns { Object } - Mengembalikan fungsi deleteDetailPengeluaran, serta status loading dan error.
 */
const useDeleteDetailPengeluaran = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Fungsi untuk menghapus detail pengeluaran di backend.
   * @param { number } id - ID detail pengeluaran yang akan dihapus.
   * @returns { Promise<boolean> } - Mengembalikan true jika berhasil, false jika gagal.
   */
  const deleteDetailPengeluaran = async (id) => {
    setLoading(true);
    setError(null);

    try {
      if (!endpoints.detail_pengeluaran || typeof endpoints.detail_pengeluaran.delete !== 'function') {
        throw new Error('endpoints.detail_pengeluaran.delete is not defined');
      }

      const response = await api.delete(endpoints.detail_pengeluaran.delete(id), {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200 || response.status === 204) {
        return true;
      } else {
        setError('Gagal menghapus detail pengeluaran.');
        return false;
      }
    } catch (err) {
      console.error('Error deleting detail pengeluaran:', err);
      setError(
        err.response?.data?.error ||
        err.response?.data?.message ||
        err.message ||
        'Terjadi kesalahan saat menghapus detail pengeluaran.'
      );
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { deleteDetailPengeluaran, loading, error };
};

export default useDeleteDetailPengeluaran;
